import { createActionGroup, props } from '@ngrx/store';
import { ToolType, SymmetryMode, ShapeFillMode } from '@models/tool.model';

export const ToolActions = createActionGroup({
  source: 'Tools',
  events: {
    'Select Tool':      props<{ tool: ToolType }>(),
    'Set Active Color': props<{ color: string }>(),
    'Add Recent Color': props<{ color: string }>(),
    'Set Brush Size':   props<{ size: number }>(),
    'Set Symmetry':     props<{ mode: SymmetryMode }>(),
    'Set Shape Fill':   props<{ mode: ShapeFillMode }>(),
  }
});
